<template>
  <div>
    <v-card v-if="firmware">
      <v-card-title>
        {{ firmware.originalname }}
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-row no-gutters>
          <v-col cols="12">
            <div class="d-inline-flex">
              <div>대상 모델</div>
              <div class="pl-4">{{ firmware.modelNo }}</div>
            </div>
          </v-col>
          <v-col cols="12">
            <div class="d-inline-flex">
              <div>대상 유형</div>
              <div class="pl-4">{{ firmware.deviceType }}</div>
            </div>
          </v-col>
          <v-col cols="12">
            <div class="d-inline-flex">
              <div>대상 버전</div>
              <div class="pl-4">{{ firmware.version }}</div>
            </div>
          </v-col>
          <v-col cols="12">
            <div class="d-inline-flex">
              <div>데이터 분할</div>
              <div class="pl-4">{{ firmware.div }}</div>
            </div>
          </v-col>
          <v-col cols="12">
            <div class="pt-2">
              {{ firmware.description }}
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-subheader>
      적용 가능 대상
      <span
        class="pl-2"
        v-if="selectedDevices.length"
      >
        ({{ selectedDevices.length }} 선택됨)
      </span>
    </v-subheader>

    <v-data-table
      v-model="selectedDevices"
      :items="items"
      :headers="headers"
      :server-items-length="count"
      :options="pagination"
      :loading="loading"
      item-key="id"
      show-select
      @update:page="move"
      :footer-props="{
        'disable-items-per-page': true,
        'items-per-page-options': []
      }"
    >
      <template v-slot:top="{ pagination, options }">
        <v-data-footer
          @update:options="move($event.page)"
          :pagination="pagination"
          :options="options"
          disable-items-per-page
          :items-per-page-options="[]"
        ></v-data-footer>
        <v-divider></v-divider>
      </template>
      <template v-slot:item.company="{ item }">
        <v-chip label small>{{ item.company || '미등록' }}</v-chip>
      </template>
      <template v-slot:item.tags="{ item }">
        <v-chip v-for="tag in item.tags" :key="tag.id" label small class="ml-1">
          {{ tag.value }}
        </v-chip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { getFirmware, getDevices } from '@/api'
import { getPaginationParams } from '@/utils'

export default {
  data () {
    return {
      firmware: null,
      selectedDevices: [],
      devices: [],
      count: 0,
      loading: false,
      headers: [
        {
          text: '모뎀 번호',
          value: 'identityNo'
        },
        {
          text: '버전',
          value: 'version'
        },
        {
          text: '소속',
          value: 'company'
        },
        {
          text: '태그',
          value: 'tags'
        }
      ],
      pagination: {
        page: 1,
        itemsPerPage: 30
      }
    }
  },
  computed: {
    items () {
      return this.devices.map(device => ({
        ...device,
        company: device.company ? device.company.name : null,
        createdAt: this.$moment(device.createdAt).format('YYYY-MM-DD HH:mm')
      }))
    }
  },
  async beforeRouteEnter (to, from, next) {
    console.log('before route enter')
    const id = to.params.id

    if (!id) return next()

    try {
      const firmware = await getFirmware(id)

      next(vm => {
        vm.firmware = firmware
        console.log('next done')
        vm.fetch(to)
      })
    } catch (err) {
      console.error(err)
      next()
    }
  },
  async beforeRouteUpdate (to, from, next) {
    try {
      await this.fetch(to)
      next()
    } catch (err) {
      next()
    }
  },
  created () {
    console.log('created')
  },
  methods: {
    async fetch (route) {
      console.log('fetch')
      this.loading = true
      const paginationParams = getPaginationParams(route)
      const filter = {
        deviceType: this.firmware.deviceType,
        modelNo: this.firmware.modelNo
      }

      const params = Object.assign({}, paginationParams, filter)

      try {
        const { items, count } = await getDevices(params)

        this.devices = items
        console.log(this.devices)
        this.count = count
      } finally {
        this.loading = false
      }
    },
    move (page) {
      if (page !== this.pagination.page) {
        this.pagination.page = page
        this.$router.push({ query: { page } })
      }
    },
    getEditPath (id) {
      return `/devices/${id}/edit`
    }
  }

}
</script>
